import React, { useState, useEffect } from 'react';
import axios from 'axios';
import link from '../link';
import { useNavigate } from "react-router-dom";
// import { useLocation } from 'react-router-dom';
// import logo from "../assets/img/logo.svg";

function Login() {
    const [mobileNo, setMobileNo] = useState('');
    const [type, setType] = useState('');
    // const [data, setData] = useState('');
    const [mobilerr, setMobilerr] = useState('');
    const [number1, setNumber1] = useState('');
    const [number2, setNumber2] = useState('');
    const [number3, setNumber3] = useState('');
    const [number4, setNumber4] = useState('');
    const [otpkey, setOtpkey] = useState('');
    const [showMe, setShowMe] = useState(false);
    const [buttonh, setButtonh] = useState(true);
    const [otperror, setotperror] = useState(false);
    const [disable, setDisable] = useState(false);
    const navigate = useNavigate();
    // const location = useLocation();
    useEffect(() => {
        // remove data from session storage
        // console.log(location);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('usertype');
    }, [navigate])

    // check if all the values are available and verify the data through api and navigate to next page and if error show the error
    useEffect(() => {
        if (number1 !== '' && number2 !== '' && number3 !== '' && number4 !== '') {
            let enter_otp = number1 + number2 + number3 + number4;
            let commonotp = '0000';
            if ((Number(enter_otp) === Number(commonotp) && enter_otp.length === 4 && type === 'default') ||
                (Number(enter_otp) === Number(commonotp) && enter_otp.length === 4 && type === 'server')) {
                axios
                    .post(`${link.apiUrl}/api/misdashboardlogin/verify/${mobileNo}`, { otp: enter_otp, session_id: otpkey })
                    .then((res) => {
                        sessionStorage.setItem('token', JSON.stringify(res.data.token));
                        // sessionStorage.setItem('token1', JSON.stringify(res.data.token1));
                        sessionStorage.setItem('user', JSON.stringify(res.data.user));
                        sessionStorage.setItem('usertype', JSON.stringify("user"));
                        // console.log(res.data.user);
                        navigate("/disclaimer");
                    })
            } else if (enter_otp.length === 4 && type === 'server') {
                axios
                    .post(`${link.apiUrl}/api/misdashboardlogin/verify/${mobileNo}`, { otp: enter_otp, session_id: otpkey })
                    .then((res) => {
                        sessionStorage.setItem('token', JSON.stringify(res.data.token));
                        // sessionStorage.setItem('token1', JSON.stringify(res.data.token1));
                        sessionStorage.setItem('user', JSON.stringify(res.data.user));
                        sessionStorage.setItem('usertype', JSON.stringify("user"));
                        // console.log(res.data.user);
                        navigate("/disclaimer");
                    })
            }
            else {
                if (enter_otp.length === 4) {
                    // alert("The OTP entered is incorrect");
                    setotperror(true);
                } else {
                    setotperror(false);
                }
            }
        }
    }, [number1, number2, number3, number4]);

    // validate if the user is entering number only and save the data
    const handleInput = (e) => {
        const { value } = e.target;
        if (/^\d+$/.test(value) || value === '') {
            setMobileNo(value);
        }
    }

    // check if mobile number is a valid number and send otp through api and show the otp box
    const otpbox = () => {
        if (mobileNo.length !== 10) {
            setMobilerr('Please Enter a Valid Mobile Number! Should Have 10 Numbers')
        } else if (mobileNo.length === 10) {
            // console.log(link.apiUrl);
            axios
                .get(`${link.apiUrl}/api/misdashboardlogin/login/${mobileNo}`)
                .then((response) => {
                    // console.log(response)
                    setOtpkey(response.data.session_id);
                    setShowMe(true);
                    setButtonh(false);
                    setMobilerr('');
                    setDisable(true);
                    setType('server');
                }).catch((error) => {
                    console.log(error);
                    setType('default');
                })
        }
    }

    // resend otp and save the otp key
    const resendotp = () => {
        axios
            .get(`${link.apiUrl}/api/misdashboardlogin/login/${mobileNo}`)
            .then((response) => {
                setOtpkey(response.data.session_id);
            }).catch((error) => {
                console.log(error);
            })
    }

    // check if otp is entered in a box, save and move to next otp box
    const handleOtp = (e) => {
        const { name, value, maxLength } = e.target;
        const [fieldName, fieldIndex] = name.split('-');
        if (value.length >= maxLength) {
            if (`${fieldName}${fieldIndex}` === "number1") {
                // console.log(value);
                setNumber1(value);
            }
            if (`${fieldName}${fieldIndex}` === "number2") {
                setNumber2(value)
            }
            if (`${fieldName}${fieldIndex}` === "number3") {
                setNumber3(value)
            }
            if (`${fieldName}${fieldIndex}` === "number4") {
                setNumber4(value)
            }
            if (parseInt(fieldIndex, 10) < 4) {
                // console.log(fieldName, fieldIndex, value);
                const nextTab = document.querySelector(
                    `input[name=number-${parseInt(fieldIndex, 10) + 1}]`
                );

                if (nextTab !== null) {
                    nextTab.focus();
                }
            }
        }
    }

    return (
        <React.Fragment>
            <div className="content">
                <div className="patientregistrationmain">
                    <div className="patientregistration">
                        {/* <img src={logo} alt="" /> */}

                        <div className="row newrow" style={{ justifyContent: 'center' }}>
                            <div className="col-md-12">
                                <div className="boxshadow padding20">
                                    <h2 className="dashboardtitleheadertext mb20">
                                        MIS Dashboard Login
                                    </h2>
                                    <h3 className="smallheading mb20">Enter Mobile Number</h3>
                                    <div className="mb-3 patientdetailsregisternumber custominput padding15">
                                        <span>+91 &nbsp;|</span>
                                        <input
                                            type="text"
                                            maxLength={10}
                                            name="mobileno"
                                            onChange={(e) => handleInput(e)}
                                            value={mobileNo}
                                            placeholder="Enter Mobile Number"
                                            disabled={disable}
                                        />
                                    </div>
                                    {mobilerr !== '' ? (
                                        <p className="error">{mobilerr}</p>
                                    ) : null}

                                    {buttonh ? (
                                        <input
                                            type="button"
                                            className="loginbluebtn width100per"
                                            onClick={() => otpbox()}
                                            value="CONTINUE"
                                        />
                                    ) : null}

                                    {showMe ? (
                                        <div className="verifybox mt30 text-center">
                                            <h3 className="smallheading mb15 fontweight500">
                                                User Details
                                            </h3>
                                            <p>
                                                Enter the OTP that user has received{' '}
                                                <span className="br">
                                                    on his mobile number as an SMS
                                                </span>
                                            </p>
                                            <form>
                                                <div className="form-group custominputotp">
                                                    <input
                                                        type="number"
                                                        name="number-1"
                                                        maxLength={1}
                                                        value={number1}
                                                        onChange={handleOtp}
                                                        placeholder=""
                                                        className="form-control custominputotpinput"
                                                    />
                                                </div>
                                                <div className="form-group custominputotp">
                                                    <input
                                                        type="number"
                                                        name="number-2"
                                                        maxLength={1}
                                                        value={number2}
                                                        onChange={handleOtp}
                                                        placeholder=""
                                                        className="custominputotpinput form-control"
                                                    />
                                                </div>
                                                <div className="form-group custominputotp">
                                                    <input
                                                        type="number"
                                                        name="number-3"
                                                        maxLength={1}
                                                        value={number3}
                                                        onChange={handleOtp}
                                                        placeholder=""
                                                        className="custominputotpinput form-control"
                                                    />
                                                </div>
                                                <div className="form-group custominputotp">
                                                    <input
                                                        type="number"
                                                        name="number-4"
                                                        maxLength={1}
                                                        value={number4}
                                                        onChange={handleOtp}
                                                        placeholder=""
                                                        className="custominputotpinput form-control"
                                                    />
                                                </div>
                                            </form>
                                            {otperror ? (
                                                <p className="mt20 error">
                                                    The OTP entered is incorrect.
                                                </p>
                                            ) : null}

                                            <p className="mt20">
                                                User didn't receive the code?{' '}
                                                <span
                                                    className="bluetext fontweight500 finpoint"
                                                    onClick={resendotp}
                                                >
                                                    Resend
                                                </span>
                                            </p>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Login;
